import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { NotificationBell } from '@/components/common/NotificationBell';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { useAuth } from '@/hooks/useAuth';
import { buildNameInitials } from '@/lib/nameInitials';

export function AdminMobileHeader() {
  const { t } = useTranslation('admin');
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const displayName = currentUser === null ? '' : currentUser.fullName;

  return (
    <header className="md:hidden bg-zooindigo px-5 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-lg bg-zooprimary flex items-center justify-center">
          <Icon name="Shield" className="text-zoowhite" />
        </span>
        <span className="font-bold text-zoowhite text-sm">{t('consoleShortName')}</span>
      </div>
      <div className="flex items-center gap-3">
        <NotificationBell />
        <LanguageSwitcher tone="dark" />
        <button
          type="button"
          aria-label={t('navigation.profile')}
          onClick={function goToProfile() {
            navigate(APPLICATION_ROUTES.adminProfile);
          }}
          className="w-10 h-10 rounded-full bg-zooviolet text-zoowhite flex items-center justify-center font-bold text-xs"
        >
          {buildNameInitials(displayName)}
        </button>
      </div>
    </header>
  );
}
